import { Injectable } from '@angular/core';
import { ChapterModel } from '../story/models/chapter.model';
import { TransitionModel } from '../story/models/transition.model';
import { Store } from '@ngxs/store';
import { get } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class TransitionService {
  constructor(private store: Store) {}

  chapterHasTransition(chapter: ChapterModel, isReverse?: boolean) {
    const key = isReverse ? 'transitions.pre' : 'transitions.post';
    const transition = get(chapter, key) as TransitionModel;

    if (!transition) {
      return false;
    }

    return isReverse ? transition.onPrevious : transition.onNext;
  }

  searchChapterTransitions(
    currentChapterId: string,
    targetChapterId: string,
    allChapters: ChapterModel[],
  ) {
    let chapters = [...allChapters];
    let currentIndex = chapters.findIndex((chapter) => chapter.id === currentChapterId);
    let targetIndex = chapters.findIndex((chapter) => chapter.id === targetChapterId);
    const isReverse = targetIndex < currentIndex;

    // When moving in reverse, flip the array so we iterate through it properly
    if (isReverse) {
      chapters = chapters.reverse();
      currentIndex = chapters.findIndex((chapter) => chapter.id === currentChapterId);
      targetIndex = chapters.findIndex((chapter) => chapter.id === targetChapterId);
    }

    // Stop if both chapters can't be found, or are identical
    if (currentIndex < 0 || targetIndex < 0 || currentIndex === targetIndex) {
      return null;
    }

    // Get a range of chapters between current and target
    // Find the next chapter with a valid and active transition in that direction
    const transitionChapter = chapters.slice(currentIndex, targetIndex).find((chapter) => {
      return this.chapterHasTransition(chapter, isReverse);
    });

    // If nothing is found, return null
    if (!transitionChapter) {
      return null;
    }

    // Return the appropriate transition
    return isReverse ? transitionChapter.transitions.pre : transitionChapter.transitions.post;
  }
}
